import { motion, AnimatePresence } from "framer-motion";
import NumberKeyboard from "../UI/elements/NumberKeyboard";

function NumberKeyboardWrapper({ showKeyboard, customPages, setCustomPages, setShowKeyboard, maxPage }) {
  if (!showKeyboard) return null;
  return (
    <motion.div
      initial={{ y: "100%", opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: "100%", opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <NumberKeyboard
        value={customPages}
        onChange={setCustomPages}
        onConfirm={() => setShowKeyboard(false)}
        maxPage={maxPage}
      />
    </motion.div>
  );
}

export default NumberKeyboardWrapper;